import React, { useMemo } from "react";
import { Loader2, AlertTriangle } from "lucide-react";
import { C } from "./igualdad-data.js";
import { IgualdadChart } from "./igualdad-charts.jsx";

/* ============================================================
   Talention — Módulo Igualdad · Componentes base
   ============================================================ */

const IgualdadDonut = ({ data, colors }) => {
  const option = useMemo(() => ({
    tooltip: {
      trigger: "item",
      borderColor: C.border,
      borderWidth: 1,
      backgroundColor: C.surface,
      textStyle: { fontSize: 12, color: C.charcoal },
      extraCssText: "border-radius:8px;",
    },
    series: [
      {
        type: "pie",
        radius: ["46%", "68%"],
        center: ["50%", "50%"],
        avoidLabelOverlap: false,
        padAngle: 2,
        label: { show: false },
        labelLine: { show: false },
        emphasis: { scale: false },
        data: data.map((d, i) => ({
          value: d.value,
          name: d.name,
          itemStyle: { color: colors[i % colors.length] },
        })),
      },
    ],
  }), [data, colors]);

  return (
    <div className="rb-donut">
      <IgualdadChart option={option} style={{ height: 150 }} />
      <div className="rb-donut-legend">
        {data.map((d, i) => (
          <span key={i}><i style={{ background: colors[i % colors.length] }} />{d.name} · {d.value}</span>
        ))}
      </div>
    </div>
  );
};

const Status = ({ loading = false, error = null, empty = false, emptyText = "No hay datos para mostrar." }) => {
  if (loading) return <div className="st-box"><Loader2 size={20} className="st-spin" /> Cargando…</div>;
  if (error) return <div className="st-box st-err"><AlertTriangle size={18} /> {typeof error === "string" ? error : "Error al cargar los datos."}</div>;
  if (empty) return <div className="st-box">{emptyText}</div>;
  return null;
};

const SectionHead = ({ icon: IconCmp, title, right }) => (
  <div className="rb-sechead">
    <div className="rb-sechead-l">
      <span className="rb-sechead-ic"><IconCmp size={15} /></span>{title}
    </div>
    {right}
  </div>
);

/* Interruptor de si/no. Es un `switch` de verdad: se anuncia con su estado,
   se enfoca con el tabulador y responde a espacio y enter, no solo al raton. */
const Toggle = ({ on = false, disabled = false, onChange, label }) => {
  const click = () => {
    if (!disabled) onChange(!on);
  };

  const tecla = (e) => {
    if (e.key !== " " && e.key !== "Enter") return;
    e.preventDefault();
    click();
  };

  return (
    <span
      role="switch"
      aria-checked={on}
      aria-label={label}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : 0}
      className={"rb-toggle" + (on ? " on" : "")}
      style={{ cursor: disabled ? "default" : "pointer", opacity: disabled ? 0.6 : 1 }}
      onClick={click}
      onKeyDown={tecla}
    ><i /></span>
  );
};

export { IgualdadDonut, Status, SectionHead, Toggle };
